import { useNavigate } from 'react-router-dom';
import { login } from '../libs/auth';
import { api } from '../libs/axios';
import Swal from 'sweetalert2';
import { formLogin } from '../schemas/login';
import { AxiosErrorResponse } from './pdv/mutationReserva';

export function useLogin() {
  const navigate = useNavigate();

  const handelSigin = async (data: formLogin) => {
    try {
      const response = await api.post('/login', data);
      
      if (response.data.error === false) {
        login(response.data.token, response.data.user);
        
        return navigate('/');
      }
    } catch (err: unknown) {
      console.log(err);

      const error = err as AxiosErrorResponse

      const message =
        error.response?.data?.data?.message ||
        error.response?.data?.message ||
        'Erro ao fazer login.';

      Swal.fire({
        icon: 'error',
        title: message,
      });

      return false;
    }
  };

  return {
    handelSigin,
  };
}
